export default __webpack_public_path__ + "static/media/Belt of the Blood Drinker (nm).81f2de7f.jpg";